import { DataModelBuilder, SerializationContext, SerializedData } from '../../models/dto/data-model.js';
import { isSameData } from '../../models/dto/data-model-utils.js';
import { NTAKCustomerDetails } from '../../models/serializable/ntak-customer-details.js';
import { MapUtils } from '../../utility/map-utils.js';
import { Component } from '../core/component.js';

export class NTAKCustomerDetailsComponent extends Component {
  static readonly TYPE_ID: string = 'c03f983bc91f451cab41c5cdb3cbc808';

  constructor(
    public readonly customerDetails: NTAKCustomerDetails,
  ) {
    super();
  }

  get $typeId(): string {
    return NTAKCustomerDetailsComponent.TYPE_ID;
  }

  get $removable(): boolean {
    return false;
  }

  static fromMap(
      context: SerializationContext,
      map: SerializedData,
  ): NTAKCustomerDetailsComponent {
    return new NTAKCustomerDetailsComponent(
        context.fromData(MapUtils.get<SerializedData>(map, 'customerDetails')),
    );
  }

  toMap(context: SerializationContext): SerializedData {
    return {
      'customerDetails': context.toData(this.customerDetails),
    };
  }

  clone(): this {
    return new NTAKCustomerDetailsComponent(
        this.customerDetails.clone(),
    ) as this;
  }

  isSame(other: this): boolean {
    if(other === this) {
      return true;
    }

    return isSameData(other.customerDetails, this.customerDetails);
  }
}

export class NTAKCustomerDetailsComponentBuilder extends DataModelBuilder<NTAKCustomerDetailsComponent> {
  build(context: SerializationContext, map: SerializedData): NTAKCustomerDetailsComponent {
    return NTAKCustomerDetailsComponent.fromMap(context, map);
  }
}
